import styled from "styled-components";
import appTheme from "../../../../themes/Theme";

export const StyledWrapper = styled.div`
  box-sizing: border-box;
  width: 80vw;
  height: 100vh;
  background-color: ${appTheme.navbarColor};
  color: ${appTheme.textColor};
  font-size: 500;
`;
export const StyledHeader = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const StyledMenuWrapper = styled.ul`
  padding: 8px;
  margin: 0;
`;
